// src/components/WhoFor.jsx
import { Building2, Truck } from "lucide-react";

export default function WhoFor() {
  const cards = [
    {
      icon: <Building2 size={40} className="text-black" />,
      title: "Yük Verenler için",
      desc: "Yük ilanını oluştur, nakliyecilerden gelen teklifleri karşılaştır ve sana en uygun olanı seç.",
    },
    {
      icon: <Truck size={40} className="text-black" />,
      title: "Nakliyeciler için",
      desc: "Boş dönüş yapma! KolayYük ile rotana uygun yükleri anında bul ve kazancını artır.",
    },
  ];

  return (
    <section className="py-24 bg-gray-50 px-6 md:px-12" id="who">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-extrabold text-black mb-12">
          Kimler İçin?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {cards.map((c, i) => (
            <div
              key={i}
              className="bg-white border-2 border-black rounded-xl p-10 flex flex-col items-center text-center hover:shadow-lg transition"
            >
              {c.icon}
              <h3 className="text-xl font-bold mt-4">{c.title}</h3>
              <p className="text-gray-600 mt-3">{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
